import { useCssInJs } from "../../../../hooks";
import cx from 'classnames';
import { genTabsStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var Tabs = function Tabs(props) {
  var options = props.options,
    value = props.value,
    onChange = props.onChange,
    size = props.size;
  var prefix = 'tabs';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTabsStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cx(prefix, hashId, size),
    children: options.map(function (item) {
      return /*#__PURE__*/_jsx("div", {
        className: cx('tabs-tab', hashId, value == item.value ? 'active' : ''),
        onClick: function onClick() {
          return onChange && onChange(item.value, item);
        },
        children: item.label
      }, item.value);
    })
  }));
};